import React, {Fragment} from "react" ;

const WieldySidebarClick = (props) =>
{
    return (
        <li className="dt-side-nav__item" key={props.keyName}>
            <div onClick={props.modal} className="dt-side-nav__link" title={props.title} style={{cursor: 'pointer'}}>
                <i className={"icon " + props.iconName + " icon-fw " + props.iconSize } key={props.keyName + 'i'}/>
                <span className="dt-side-nav__text" key={props.keyName + 'span'}>{props.title}</span>
            </div>
        </li>
    ) ;
}

export default WieldySidebarClick;
